import type { Catalog } from '../types';

// PaywallOverlay: the paywall gate, donation gate, price cards, trial/promo
// badges, and trust line. Publisher-authored overrides (paywallText, ctaLabel,
// trialBadgeLabel, badgeLabel, price names) are NOT here — they render verbatim;
// these are the computed defaults they fall back to.
export const paywall: Catalog = {
  'paywall.eyebrow': 'Members only',
  'paywall.title.subscribe': 'Subscribe for full access',
  'paywall.title.unlock': 'Unlock access',
  'paywall.subtitle.mixed': 'Subscribe for full access, or make a one-time purchase.',
  'paywall.subtitle.oneTime': 'Make a one-time purchase to unlock access.',
  'paywall.subtitle.subscribe': 'Subscribe to unlock everything behind the paywall.',
  'paywall.login.subscribed': 'Already subscribed? Log in',
  'paywall.login.purchased': 'Already purchased? Log in',
  // Fragment: the email renders after it wrapped in <strong>.
  'paywall.purchasingAs': 'Purchasing as',
  'paywall.notYou': 'Not you?',

  'cta.subscribe': 'Subscribe',
  'cta.buy': 'Buy',
  'cta.donate': 'Donate',
  'cta.continue': 'Continue',
  'cta.startTrial': {
    one: 'Start {days}-day free trial',
    other: 'Start {days}-day free trial',
  },

  // Raw template: the {days} token must survive untranslated — TrialBadge splits
  // around it to keep the day count an editable span in the preview.
  'trialBadge.default': '{days}-day free trial',

  'priceLabel.daily': 'Daily',
  'priceLabel.weekly': 'Weekly',
  'priceLabel.monthly': 'Monthly',
  'priceLabel.yearly': 'Yearly',
  'priceLabel.oneTime': 'One-time',
  'priceLabel.everyInterval': 'Every {interval}',
  'priceLabel.everyCount': {
    one: 'Every {count} {interval}',
    other: 'Every {count} {interval}',
  },
  'paywall.intervalPer': 'per {interval}',
  'paywall.intervalEvery': {
    one: 'every {count} {interval}',
    other: 'every {count} {interval}',
  },
  // The campaign code's confirmation line under the plan list. Raw template:
  // the {code} token must survive untranslated — PromoAppliedText splits
  // around it to keep the code in a notranslate span (the TrialBadge pattern).
  'paywall.promoApplied': '{code} applied',

  'interval.day': { one: 'day', other: 'days' },
  'interval.week': { one: 'week', other: 'weeks' },
  'interval.month': { one: 'month', other: 'months' },
  'interval.year': { one: 'year', other: 'years' },

  'donation.eyebrow': 'Support',
  // Raw template: donateButtonLabel substitutes the {amount} token itself.
  'donation.ctaDefault': 'Donate {amount}',
  'donation.chooseAmount': 'Choose an amount',
  'donation.other': 'Other',
  'donation.enterAmount': 'Enter an amount',
  'donation.customAmountAria': 'Custom donation amount',
  'donation.minimum': 'Minimum {amount}',
  'donation.maximum': 'Maximum {amount}',

  'trust.secureCheckout': 'Secure checkout by Stripe',
  'trust.cancelAnytime': 'Cancel anytime',
  'trust.manageSubscription': 'Manage subscription',
};
